import { useQuery } from '@tanstack/react-query';
import { getNewManagements } from '../service';

export function useNewManagements(page: number = 1) {
    const query = useQuery({
        queryKey: ['integrated-properties', 'new-managements', { page }],
        queryFn: () => getNewManagements({ page }),
        refetchOnWindowFocus: true,
    });

    return query;
}
